import React, { useState, createContext, useContext } from "react";

const CartContext = createContext();

// HOOK
export const useCart = () => useContext(CartContext);

// PROVIDER
export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState([]);

  const addToCart = (product, quantity, isIncrementing = true) => {
    setCart((prevCart) => {
      const isFound = prevCart.find((item) => item._id === product._id);
      if (isFound) {
        // product already in cart, update the quantity
        return prevCart.map((item) =>
          item._id === product._id
            ? {
                ...item,
                quantity: isIncrementing
                  ? item.quantity + 1
                  : Math.max(item.quantity - 1, 1),
              }
            : item
        );
      } else {
        // product is not in the cart, add a new product
        return [...prevCart, { ...product, quantity: quantity }];
      }
    });
  };

  const removeFromCart = (productId) => {
    setCart((prevCart) =>
      prevCart.reduce((acc, product) => {
        if (product._id === productId) {
          if (product.quantity > 1) {
            // Reduce quantity if more than one
            acc.push({ ...product, quantity: product.quantity - 1 });
          }
        } else {
          acc.push(product);
        }
        return acc;
      }, [])
    );
  };

  const removeProduct = (productId) => {
    setCart((prevCart) =>
      prevCart.filter((item) => {
        return item._id !== productId;
      })
    );
  };

  const clearCart = () => {
    setCart([]);
  };

  const deliveryCharge = 0;
  const discount = 0;
  const subtotal = cart.reduce(
    (acc, item) => acc + item.price * item.quantity,
    0
  );
  const total = subtotal + deliveryCharge - discount;

  return (
    <CartContext.Provider
      value={{
        cart,
        clearCart,
        addToCart,
        removeFromCart,
        removeProduct,
        total,
        subtotal,
        deliveryCharge,
        discount,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};
